











































































import { Component } from 'vue-property-decorator';
import Overlay from '@/components/overlays/Overlay.vue';
import TextFieldOnInput from '@/components/form/TextFieldOnInput.vue';
import TextField from '@/components/form/TextField.vue';
import Button from '@/components/Button.vue';
import NewTranslation from '@/components/i18n/NewTranslation.vue';
import { Getter, namespace } from 'vuex-class';
import AccommodationProjection from '@/types/projections/AccommodationProjection';
import Loader from '@/components/Loader.vue';
import debounce from '@/app/utils/debounce';

const BookingModule = namespace('booking');

@Component({
  components: { Loader, NewTranslation, Button, TextFieldOnInput, TextField, Overlay },
})
export default class AccommodationSelectOverlay extends Overlay {
  searchText = '';
  selectedEntry: AccommodationProjection = {};
  hasSearched: boolean = false;
  isLoading: boolean = false;
  page: string = 'search';
  customEntry = {
    name: '',
    addressStreetAndNumber: '',
    addressZip: '',
    addressCity: '',
  };

  public debouncedSearch: (text: string) => void | (() => void) = () => {};

  mounted() {
    this.debouncedSearch = debounce((text: string) => this.searchInner(text), 200);

    this.reset();
  }

  selectEntry(entry: AccommodationProjection) {
    this.selectedEntry = entry;
  }

  public get selectedId(): number {
    return this.selectedEntry ? this.selectedEntry.id || 0 : 0;
  }

  public get canConfirm(): boolean {
    return ((this.page === 'search' && this.selectedId) ||
      (this.page === 'custom' && this.customEntry.name && this.customEntry.addressStreetAndNumber)) as boolean;
  }

  setPage(page: string) {
    this.page = page;
  }

  search() {
    this.searchInner(this.searchText);
  }

  searchInner(text: string) {
    if (!text || !text.trim()) {
      this.reset();
      return;
    }

    this.isLoading = true;
    this.searchAccommodations({ query: text }).then(() => {
      this.hasSearched = true;
      this.isLoading = false;
    });
  }

  onOpen() {
    // @ts-ignore
    this.open();
  }

  onClose() {
    this.reset();
    // @ts-ignore
    this.close();
  }

  confirm() {
    if (this.page === 'custom') {
      this.selectedEntry = { ...this.customEntry };
    }
    if (this.selectedEntry) {
      this.$emit('confirm', this.selectedEntry);
      this.reset();
      // @ts-ignore
      this.close();
    }
  }

  reset() {
    this.resetSearchAccommodations();
    this.hasSearched = false;
    this.selectedEntry = {};
    this.setPage('search');
  }

  selectCustomEntry() {
    this.customEntry.name = this.searchText;
    this.setPage('custom');
  }

  backToSearch() {
    this.customEntry = {
      name: '',
      addressStreetAndNumber: '',
      addressZip: '',
      addressCity: '',
    };
    this.setPage('search');
  }

  @Getter
  public strictAccommodationSelection!: boolean;

  @BookingModule.Action
  public searchAccommodations!: any;

  @BookingModule.Action
  public resetSearchAccommodations!: any;

  @BookingModule.Getter
  public accommodations!: AccommodationProjection[];
}
